import TechAddToCart from './TechAddToCart';

export default TechAddToCart;
